import useSWR from 'swr';

import { Section, SectionAlternate } from '@/src/components/organisms';

import { FooterNewsletter, Partners, Featured } from './components';

export default function ExploreView() {
  const { data } = useSWR('/commons/cms/institutions/');

  return (
    <div>
      <Section>
        <Partners partners={data?.slice(0, 6)} />
      </Section>
      <SectionAlternate>
        <Featured institutions={data?.slice(0, 4)} />
      </SectionAlternate>
      <Section>
        <FooterNewsletter />
      </Section>
    </div>
  );
}
